import React from "react";
import css from "./ServiceDropdown.css";
import Select from "../common/StyledSelect";
import PropTypes from "prop-types";

const ServiceDropdown = props => {

  const serviceOptions = services => services.map(service => ({ value: service.serviceId, label: service.name }));
  return (
    <div className={css['select-container']}>
      <div className={css['field-label']}>
        <span aria-hidden={true} className={css['star-required']}>* </span>
        <label htmlFor="services-select">Service: </label>
      </div>
      <div className={css['service-select']}>
        <Select
          id="services-select"
          placeholder="Select a service"
          options={serviceOptions(props.services)}
          onChange={selectedService => props.setSelectedService(selectedService)}
          value={props.selectedService}
          maxMenuHeight={730}
          isClearable={true}
          isSearchable={true}
        />
      </div>
      <div className={css['spacer']}>
      </div>
    </div>
  )
};

ServiceDropdown.propTypes = {
  services: PropTypes.array.isRequired,
  setSelectedService: PropTypes.func.isRequired,
  selectedService: PropTypes.object
};

export default ServiceDropdown;
